export default "__VITE_PUBLIC_ASSET__276b3771__"